<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">settings</v-icon> Aplicaciones</h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :widthModal="800"
          v-if="$util.isRol('SUPERADMIN')"
        >
          <template slot="buttons">
            <v-tooltip bottom v-if="$store.state.permissions['entidades:create']">
              <v-btn color="primary"
                @click.native.stop="openModal()"
                slot="activator">
                <v-icon>add</v-icon> {{$t('common.add') }}
              </v-btn>
              <span>{{$t('entity.add')}}</span>
            </v-tooltip>
          </template>

          <template slot="form">
            <v-card-title class="headline">
              <v-flex xs9>
                <v-icon>settings</v-icon> Agregar Aplicacion
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs1 text-md-right>
                <v-btn icon @click.native="$store.commit('closeModal')">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-card-title>
            <v-form
              @submit.prevent="save"
              v-model="valid"
              ref="form"
              lazy-validation
              >
              <v-card-text class="pt-0">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="nombre"
                        label="Nombre"
                        id="nombre"
                        v-model="form.nombre"
                        autofocus
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        id="descripcion"
                        name="descripcion"
                        :label="$t('entity.crud.description')"
                        v-model="form.descripcion"
                        :counter="500"
                        :rules="$validate(['required'])"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <small class="error--text text-required">* Los campos son obligatorios</small>
                <v-spacer></v-spacer>
                <v-btn
                  @click.native="$store.commit('closeModal');">
                  <v-icon>cancel</v-icon> {{$t('common.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  type="submit"
                  :disabled="!valid">
                  <v-icon>check</v-icon> {{$t('common.save') }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </template>

          <template slot="items" slot-scope="items">
            <td class="nowrap">
              <v-tooltip bottom v-if="$store.state.permissions['aplicaciones:update']">
                <v-btn
                  icon
                  slot="activator"
                  @click.native="editItem(items.item.id, 'entidad', dataGraphql)">
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
            </td>
            <td>
              <v-tooltip bottom v-if="$store.state.permissions['aplicaciones:update']">
                <v-switch
                  v-model="items.item.active"
                  value="ACTIVE"
                  @change="changeActive(items.item, items.item.id, 'entidad', 'EditEntidad')"
                  hide-details
                  v-if="idEntidad != items.item.id"
                  slot="activator"
                  color="success"></v-switch>
                <span>Activar/desactivar registro</span>
              </v-tooltip>
            </td>
            <td>{{ items.item.nombre }}</td>
            <td>{{ items.item.descripcion }}</td>
            <td>{{items.item.token}}</td>
          </template>
        </crud-table>
       
      </v-card-text>
    </v-card>
  </section>
</template>
<script>

import CrudTable from '@/common/util/crud-table/CrudTable.vue';
import crud from '@/common/util/crud-table/mixins/crud-table';
import validate from '@/common/mixins/validate';

export default {
  mixins: [ crud, validate ],
  data () {
    return {
      logDatos: null,
      successAlert: false,
      graphql: true, // Definiendo el CRUD con Graphql
      url: 'v1/aplicaciones',
      headers: [
        { text: this.$t('common.actions'), sortable: false },
        { text: this.$t('common.active'), sortable: false },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Descripcion', value: 'descripcion' },
        { text: 'Token', value: 'token' }
      ],
      form: {
        nombre: '',
        descripcion: '',
        caducidad: 0
      },
      valid: true,
      user: null
    };
  },
  created () {
    this.user = this.$storage.getUser();
  },
  methods: {
    openModal (data = {}, form = true) {
      this.valid = true;
      this.$refs.form.reset();
      this.logDatos = null;
      this.form = {
        nombre: '',
        descripcion: '',
        caducidad: 0
      };
      if (form) {
        this.$store.commit('openModal');
      }
    },
    save () {
      if (this.$refs.form.validate()) {
        let data = Object.assign({}, this.form);
        data.estado = 'ACTIVO';
        this.$service['post'](this.url, data).then(response => {
          if (response) {
            this.$store.commit('closeModal');
            this.updateList();
            this.$message.success();
          }
        });
      }
    }
  },
  components: {
    CrudTable
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/aplicacion/Aplicacion.vue